export const SET_HAS_FAMILY_STRUCTURE = 'SET_HAS_FAMILY_STRUCTURE';

export const SetHasFamilyStructure = (value) => {
    return {
        type: SET_HAS_FAMILY_STRUCTURE,
        payload: {
            value: value
        }
    }
}